import tableVodAppManager from './formGroupLiveApps/tableVodAppManager';

export default {
  title: 'Vod Graphic managers',
  attributeName: 'vodGraphicManagers',
  getURL: 'vodgraphicmanagers',
  createURL: 'vodgraphicmanagers',
  updateURL: 'vodgraphicmanagers',
  removeURL: 'vodgraphicmanagers',
  sessionParams: [],
  noArea: true,
  tableConfig: tableVodAppManager,
  sessionWebsocketParams: [],
  // websocketEventChanel: 'vod',
  // websocketItem: 'vod',
  autoUpdate: true,
  // websocketNavigation:'users_navigation',

};




